import styled from 'styled-components'
import { Button as btn, Input as Inp } from 'antd'
import { Lightbulb } from '@styled-icons/bootstrap/Lightbulb'
import { Mail } from '@styled-icons/fluentui-system-filled/Mail'
import { BlueLight, White } from '../../constants/constants'

export const RowHeader = styled.article`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${White};
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  @media (max-width: 600px) {
    height: auto;
  }
  height: auto;
  margin: 0px auto;
`

export const SubmitWrapper = styled.div`
  position: sticky;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: var(--bq-spacing-s);
  width: 100%;
  bottom: 0;
  background-color: white;
`
export const Button = styled(btn)`
  margin-left: auto;
`

export const SaveButtonWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const Input = styled(Inp)`
  width: 300px;
`

export const BubbleButton = styled(Lightbulb)`
  color: black;
  margin-bottom: 3px;
`

export const MailIcon = styled(Mail)`
  color: black;
  margin-bottom: 2px;
`
export const EditTitle = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  color: ${BlueLight};
  margin-top: 37px;
`
export const ContainerLinks = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const OnePageProfileDivider = styled.div`
  margin: 10px 0px;
  color: #8d8d8d;
  display: flex;
  gap: 16px;

  div {
    flex: 1;
    height: 1px;
    background-color: #c9c9c9;
    margin: auto;
  }
`
